"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FutureManualProcessor = exports.BINANCE_SWAP_MIN_INVEST = exports.FutureManualTradeType = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
var FutureManualTradeType;
(function (FutureManualTradeType) {
    FutureManualTradeType["limit"] = "limit";
    FutureManualTradeType["market"] = "market";
    FutureManualTradeType["stop_limit"] = "stop_limit";
    FutureManualTradeType["stop_limit_market"] = "stop_limit_market";
})(FutureManualTradeType = exports.FutureManualTradeType || (exports.FutureManualTradeType = {}));
const MAX_MARGIN_INVEST = 20;
// 币安合约限制最小交易额5U
exports.BINANCE_SWAP_MIN_INVEST = 5;
// export interface FutureManualParams {
//     side: ExchangeOrderSide;
//     tradeType: FutureManualTradeType;
//     marginType: FutureMarginType;
//     leverage: string;
//     price: string;
//     triggerPrice: string;
//     tradePrice: string; // 预计成交湿的买卖价
//     amount: string;
//     amountPercent: number | undefined;
//     amountError: string;
//     maxAmount: string;
//     balance: string;
//     requiredMargin: string;
//     symbol: ExchangeSymbol;
//     isPostOnly: boolean;
//     isReduceOnly: boolean;
//     isSupportReduceOnly: boolean;
//     orderType: FutureOrderType;
//     enableChangeMarginType: boolean;
//     triggerType: FutureWorkingType;
// }
// // bid买 ask卖
exports.FutureManualProcessor = {
    //     useUserParams: (
    //         side: ExchangeOrderSide,
    //         tradeType: FutureManualTradeType,
    //         marginType: FutureMarginType,
    //         leverage: string,
    //         triggerPrice: string,
    //         price: string,
    //         amount: string,
    //         amountPercent: number,
    //         amountActionType: SliderActionType,
    //         position: FuturePosition,
    //         maxInvest: string,
    //         balance: number | string,
    //         symbol: ExchangeSymbol,
    //         isPostOnly: boolean,
    //         curPrice: number,
    //         markPrice: string,
    //         ask1: string,
    //         bid1: string,
    //         isReduceOnly: boolean,
    //         $st: StringFormatter,
    //         isClosePosition: boolean = false,
    //         triggerType: FutureWorkingType = FutureWorkingType.CONTRACT_PRICE,
    //     ): FutureManualParams => {
    //         const orderType: FutureOrderType = useMemo(() => {
    //             switch (tradeType) {
    //                 case FutureManualTradeType.limit:
    //                     return FutureOrderType.LIMIT;
    //                 case FutureManualTradeType.market:
    //                     return FutureOrderType.MARKET;
    //                 case FutureManualTradeType.stop_limit:
    //                 case FutureManualTradeType.stop_limit_market:
    //                     const trigger = new SafeDecimal(triggerPrice);
    //                     const cur = triggerType === FutureWorkingType.CONTRACT_PRICE ? new SafeDecimal(curPrice) : new SafeDecimal(markPrice);
    //                     const isTriggerBigger = trigger.greaterThanOrEqualTo(cur);
    //                     if (tradeType === FutureManualTradeType.stop_limit) {
    //                         if (side === ExchangeOrderSide.buy) {
    //                             return isTriggerBigger ? FutureOrderType.STOP : FutureOrderType.TAKE_PROFIT;
    //                         } else {
    //                             return isTriggerBigger ? FutureOrderType.TAKE_PROFIT : FutureOrderType.STOP;
    //                         }
    //                     } else {
    //                         if (side === ExchangeOrderSide.buy) {
    //                             return isTriggerBigger ? FutureOrderType.STOP_MARKET : FutureOrderType.TAKE_PROFIT_MARKET;
    //                         } else {
    //                             return isTriggerBigger ? FutureOrderType.TAKE_PROFIT_MARKET : FutureOrderType.STOP_MARKET;
    //                         }
    //                     }
    //             }
    //         }, [tradeType, side, curPrice, triggerPrice]);
    //         const isSupportReduceOnly = useMemo(() => {
    //             if (tradeType === FutureManualTradeType.stop_limit || tradeType === FutureManualTradeType.stop_limit_market) {
    //                 return true;
    //             }
    //             const positionDecimal = new SafeDecimal(position.position);
    //             if (side === ExchangeOrderSide.buy) {
    //                 return positionDecimal.lessThan(0); // 持有空仓, 则支持买时reduce only
    //             } else {
    //                 return positionDecimal.greaterThan(0); // 持有多仓, 则支持卖时reduce only
    //             }
    //         }, [position.position, side, tradeType]);
    //         // 看多持仓, 看空持仓
    //         const [longPosition, shortPosition] = useMemo(() => {
    //             const p = NumberCommonUtils.formatterDecimal(position.position, symbol.amount);
    //             const long = p.greaterThan(0) ? p : new SafeDecimal(0);
    //             const short = p.lessThan(0) ? p.abs() : new SafeDecimal(0);
    //             return [long, short];
    //         }, [position.position, symbol.amount]);
    //         // 保证金
    //         const balanceAvailable = useMemo(() => {
    //             return NumberCommonUtils.formatterDecimalToStr(balance, symbol.precision);
    //         }, [balance, symbol.precision]);
    //         /**
    //          * 用于下单前计算实际交易的价格 (预估挂单价)
    //          * 限价为price
    //          * 市价为当前价格
    //          * 市价止盈止损为触发价
    //          */
    //         const tradePrice = useMemo(() => {
    //             let transPrice = new SafeDecimal(0);
    //             switch (tradeType) {
    //                 case FutureManualTradeType.limit:
    //                 case FutureManualTradeType.stop_limit:
    //                     transPrice = new SafeDecimal(price);
    //                     break;
    //                 case FutureManualTradeType.market:
    //                 case FutureManualTradeType.stop_limit_market: //其实市价止盈止损该用触发价, 这是币安的bug, 还得适配它
    //                     transPrice = new SafeDecimal(markPrice);
    //                     break;
    //                 case FutureManualTradeType.stop_limit_market:
    //                     transPrice = new SafeDecimal(triggerPrice);
    //                     break;
    //                 default:
    //                     break;
    //             }
    //             return NumberCommonUtils.formatterDecimalToStr(transPrice, symbol.precision);
    //         }, [price, triggerPrice, tradeType, markPrice, symbol.precision]);
    //         // 开单保证金预估价格
    //         const assumingPrice = useMemo(() => {
    //             let _price = new SafeDecimal(0);
    //             switch (tradeType) {
    //                 case FutureManualTradeType.limit:
    //                 case FutureManualTradeType.stop_limit:
    //                     if (side === ExchangeOrderSide.buy) {
    //                         _price = new SafeDecimal(price);
    //                     } else {
    //                         _price = SafeDecimal.max(new SafeDecimal(bid1), new SafeDecimal(markPrice), new SafeDecimal(price));
    //                     }
    //                     break;
    //                 case FutureManualTradeType.market:
    //                 case FutureManualTradeType.stop_limit_market: //其实市价止盈止损该用触发价, 这是币安的bug, 还得适配它
    //                     if (side === ExchangeOrderSide.buy) {
    //                         _price = new SafeDecimal(ask1).mul(1.0005);
    //                     } else {
    //                         _price = SafeDecimal.max(new SafeDecimal(bid1), new SafeDecimal(markPrice));
    //                     }
    //                     break;
    //                 default:
    //                     break;
    //             }
    //             return NumberCommonUtils.formatterDecimalToStr(_price, symbol.precision);
    //         }, [price, triggerPrice, tradeType, side, ask1, bid1, markPrice]);
    //         // 另一方向的持仓
    //         const [reversePosition, sameWayPosition] = useMemo(() => {
    //             return [
    //                 side === ExchangeOrderSide.buy ? shortPosition : longPosition,
    //                 side === ExchangeOrderSide.buy ? longPosition : shortPosition,
    //             ];
    //         }, [side, longPosition, shortPosition]);
    //         // 反向的持仓卖掉后, 在去买当前方向的持仓. 比如-100的仓位, 市价卖掉后变0, 用卖掉的钱再买100. 结果为 abs(-100)+100 = 200
    //         const positionCanBuy = useMemo(() => {
    //             if (reversePosition.equals(0)) {
    //                 return "0";
    //             }
    //             const pCanBuy = reversePosition.mul(2);
    //             return NumberCommonUtils.formatterDecimalToStr(pCanBuy, symbol.amount);
    //         }, [symbol, reversePosition]);
    //         // MAX_MARGIN_INVEST 的限制: 只在逐仓有效
    //         const marginLimit = useMemo(() => {
    //             if (isReduceOnly) {
    //                 return 200;
    //             }
    //             return MAX_MARGIN_INVEST;
    //             // let initMargin = new SafeDecimal(position.init_margin);
    //             // if (position.margin_type === FutureMarginType.CROSS) {
    //             //     initMargin = new SafeDecimal(position.position)
    //             //     .mul(new SafeDecimal(position.mark_price))
    //             //     .div(new SafeDecimal(position.leverage))
    //             //     .abs()
    //             // }
    //             // let limitMargin = new SafeDecimal(MAX_MARGIN_INVEST);
    //             // if (new SafeDecimal(position.position).greaterThanOrEqualTo(0)) {
    //             //     if (side === ExchangeOrderSide.buy) {
    //             //         // 已经有买的持仓, 继续买, 则减去已经用掉的保证金额度
    //             //         limitMargin = limitMargin.sub(initMargin)
    //             //     } else {
    //             //         // 已经有卖的持仓, 进行买, 加上卖方向的保证金额度
    //             //         limitMargin = limitMargin.add(initMargin)
    //             //     }
    //             // } else {
    //             //     if (side === ExchangeOrderSide.buy) {
    //             //         limitMargin = limitMargin.add(initMargin)
    //             //     } else {
    //             //         limitMargin = limitMargin.sub(initMargin)
    //             //     }
    //             // }
    //             // if (limitMargin.lessThanOrEqualTo(0)) {
    //             //     limitMargin = new SafeDecimal(0);
    //             // }
    //             // return limitMargin.toString();
    //         }, [position, side, leverage, isReduceOnly, isClosePosition, MAX_MARGIN_INVEST]);
    //         // 加杠杆后限制中的保证金能买到多少仓位
    //         const marginLimitCanBuy = useMemo(() => {
    //             return FutureManualProcessor.calculateMarginCanBuy(
    //                 marginLimit,
    //                 side,
    //                 tradeType,
    //                 tradePrice,
    //                 markPrice,
    //                 assumingPrice,
    //                 leverage,
    //                 symbol,
    //             );
    //         }, [marginLimit, leverage, assumingPrice, tradePrice, symbol, symbol, tradeType, markPrice, side]);
    //         // 加杠杆后余额能买到多少仓位
    //         const marginCanBuy = useMemo(() => {
    //             return FutureManualProcessor.calculateMarginCanBuy(
    //                 balance,
    //                 side,
    //                 tradeType,
    //                 tradePrice,
    //                 markPrice,
    //                 assumingPrice,
    //                 leverage,
    //                 symbol,
    //             );
    //         }, [balance, leverage, assumingPrice, tradePrice, symbol, symbol, tradeType, markPrice, side]);
    //         // 当前balance能买到的最大值
    //         const maxBalanceBuy = useMemo(() => {
    //             if (isReduceOnly || isClosePosition) {
    //                 return NumberCommonUtils.formatterDecimalToStr(new SafeDecimal(reversePosition).abs(), symbol.amount);
    //             }
    //             if (!Number(assumingPrice)) {
    //                 return "0";
    //             }
    //             // 仓位最大限制
    //             const positionLimitTemp = new SafeDecimal(maxInvest).div(assumingPrice).add(reversePosition).sub(sameWayPosition);
    //             const positionLimit = SafeDecimal.max(positionLimitTemp, 0);
    //             // 能买到的最大持仓
    //             const canBuy = new SafeDecimal(positionCanBuy).add(new SafeDecimal(marginCanBuy));
    //             if (new SafeDecimal(maxInvest).greaterThan(0)) {
    //                 return NumberCommonUtils.formatterDecimalToStr(SafeDecimal.min(positionLimit, canBuy), symbol.amount);
    //             } else {
    //                 return NumberCommonUtils.formatterDecimalToStr(canBuy, symbol.amount);
    //             }
    //         }, [isReduceOnly, reversePosition, positionCanBuy, marginCanBuy, maxInvest, assumingPrice, symbol.amount, isClosePosition]);
    //         const maxBuy = useMemo(() => {
    //             if (isClosePosition || isReduceOnly) {
    //                 return NumberCommonUtils.formatterDecimalToStr(maxBalanceBuy, symbol.amount);
    //             } else {
    //                 return NumberCommonUtils.formatterDecimalToStr(
    //                     SafeDecimal.min(maxBalanceBuy, new SafeDecimal(marginLimitCanBuy)),
    //                     symbol.amount,
    //                 );
    //             }
    //         }, [maxBalanceBuy, marginLimitCanBuy, symbol, isClosePosition, isReduceOnly]);
    //         const [parseAmount, parseAmountSlider] = TextAndSliderSyncTool.useInvestAndInvestPercent(
    //             amountActionType,
    //             tradePrice,
    //             amount,
    //             amountPercent,
    //             ExchangeOrderSide.sell,
    //             maxBuy,
    //             symbol.amount,
    //             tradeType !== FutureManualTradeType.market,
    //         );
    //         // 所需保证金
    //         const requiredMargin = useMemo(() => {
    //             if (!Number(parseAmount)) {
    //                 return "0";
    //             }
    //             // 需要用到保证金的amount
    //             const needMarginAmount = new SafeDecimal(parseAmount).sub(new SafeDecimal(positionCanBuy));
    //             if (needMarginAmount.greaterThan(0)) {
    //                 // 初始保证金
    //                 const margin = needMarginAmount.mul(assumingPrice).div(new SafeDecimal(leverage));
    //                 // 方向
    //                 const direction = new SafeDecimal(side === ExchangeOrderSide.buy ? 1 : -1);
    //                 // 开仓亏损
    //                 const isLimitOrder = tradeType === FutureManualTradeType.limit || tradeType === FutureManualTradeType.stop_limit;
    //                 const calPrice = new SafeDecimal(isLimitOrder ? tradePrice : assumingPrice);
    //                 const deficit = needMarginAmount.mul(SafeDecimal.min(0, direction.mul(new SafeDecimal(markPrice).sub(calPrice))).abs());
    //                 // 所需保证金 = 所需保证金+开仓亏损
    //                 return NumberCommonUtils.formatterDecimalToStr(margin.add(deficit), symbol.precision);
    //             }
    //             return "0";
    //         }, [parseAmount, side, maxBuy, isReduceOnly, tradePrice, assumingPrice, tradeType, markPrice, price, ask1, bid1]);
    //         const minAmount = useMemo(() => {
    //             const symbolMin = SimpleTrading.getMinAmount(symbol, tradePrice);
    //             if (isReduceOnly) {
    //                 return symbolMin;
    //             }
    //             const limitMinAmountDecimal = new SafeDecimal(BINANCE_SWAP_MIN_INVEST).div(new SafeDecimal(tradePrice));
    //             const limitMinAmount = NumberCommonUtils.formatterDecimal(limitMinAmountDecimal, symbol.amount, SafeDecimal.ROUND_CEIL);
    //             return SafeDecimal.max(limitMinAmount, new SafeDecimal(symbolMin)).toNumber();
    //         }, [symbol, tradePrice, leverage, isReduceOnly]);
    //         const amountError = useMemo(() => {
    //             const parseAmountD = new SafeDecimal(parseAmount);
    //             if (parseAmountD.equals(0)) {
    //                 return "";
    //             }
    //             const isStopLimit = tradeType === FutureManualTradeType.stop_limit || tradeType === FutureManualTradeType.stop_limit_market;
    //             if (isStopLimit && !isClosePosition && isReduceOnly) {
    //                 // 止盈止损在非平仓, 不打开仅减仓时才去检查数量
    //                 return "";
    //             }
    //             const max = new SafeDecimal(maxBuy);
    //             const min = new SafeDecimal(minAmount);
    //             if (parseAmountD.greaterThan(max)) {
    //                 if (Number(marginLimit) && new SafeDecimal(requiredMargin).greaterThanOrEqualTo(new SafeDecimal(marginLimit))) {
    //                     return $st("future_required_margin_too_large", { max: `${marginLimit} ${symbol.quote}` });
    //                 }
    //                 return $st("trade_amount_need_less", { max: `${maxBuy} ${symbol.baseDisplay}` });
    //             } else if (parseAmountD.lessThan(min)) {
    //                 return $st("trade_amount_need_more", { min: `${minAmount} ${symbol.baseDisplay}` });
    //             }
    //             return "";
    //         }, [parseAmount, maxBuy, minAmount, $st, symbol, tradeType, isClosePosition, isReduceOnly, marginLimit, requiredMargin]);
    //         const enableChangeMarginType = useMemo(() => {
    //             return new SafeDecimal(position.position).equals(0);
    //         }, [position.position]);
    //         return {
    //             side,
    //             tradeType,
    //             marginType,
    //             leverage,
    //             price,
    //             triggerPrice,
    //             amount: parseAmount,
    //             amountPercent: parseAmountSlider,
    //             amountError,
    //             maxAmount: maxBuy,
    //             balance: balanceAvailable,
    //             requiredMargin,
    //             tradePrice,
    //             symbol: symbol,
    //             isPostOnly,
    //             isReduceOnly,
    //             isSupportReduceOnly,
    //             orderType,
    //             enableChangeMarginType,
    //             triggerType,
    //         };
    //     },
    useLeverageConfigure(base, quote, api) {
        const [configure, setConfigure] = (0, react_1.useState)(undefined);
        (0, react_1.useEffect)(() => {
            const sub = (0, trade_utils_lib_1.requestWithRetry)(() => {
                return api.requestLeverageConfigures();
            }, { name: "requestLeverageConfigures", maxRetryCount: 2 }).subscribe((data) => {
                if (data) {
                    const leverage_level = data.leverage_levels.find((value) => {
                        const findKey = `${base}_${quote}`;
                        const index = value.symbols.indexOf(findKey);
                        return index >= 0;
                    });
                    if (leverage_level) {
                        setConfigure(leverage_level);
                    }
                    else {
                        console.log(`FutureManualProcessor leverage_configs.json not get symbol: ${base}/${quote}`);
                    }
                }
                else {
                    console.log(`FutureManualProcessor leverage_configs.json not get`);
                }
            }, (error) => {
                console.log(error);
            });
            return () => {
                sub.unsubscribe();
            };
        }, [base, quote, api]);
        return configure;
    },
    useMaxPositionForSymbol(base, quote, leverage, api) {
        const configure = this.useLeverageConfigure(base, quote, api);
        return (0, react_1.useMemo)(() => {
            if (!configure) {
                return "0";
            }
            const max_position_levels = configure.max_position_levels.sort((a, b) => {
                return b.leverage - a.leverage;
            });
            let value = "0";
            for (let i = 0; i < max_position_levels.length; i++) {
                const positionConfig = max_position_levels[i];
                if (leverage <= positionConfig.leverage) {
                    value = new trade_utils_lib_1.SafeDecimal(positionConfig.value || 0).toString();
                }
                else {
                    break;
                }
            }
            return value;
        }, [configure, leverage]);
    },
    // 获取预计盈亏: 不需要的相关参数传空串.
    // usePositionEstProfit(
    //     position: FuturePosition,
    //     symbol: ExchangeSymbol,
    //     tradeType: FutureManualTradeType,
    //     amount: string,
    //     price: string,
    //     triggerPrice: string,
    //     curPrice: string,
    // ) {
    //     return useMemo(() => {
    //         if (!Number(amount)) {
    //             return "--";
    //         }
    //         let calPrice = new SafeDecimal(0);
    //         const amountDecimal = new SafeDecimal(amount);
    //         const openPrice = new SafeDecimal(position.open_price);
    //         switch (tradeType) {
    //             case FutureManualTradeType.limit:
    //             case FutureManualTradeType.stop_limit:
    //                 if (!Number(price)) {
    //                     return "--";
    //                 }
    //                 calPrice = new SafeDecimal(price);
    //                 break;
    //             case FutureManualTradeType.market:
    //                 if (!curPrice) {
    //                     return "--";
    //                 }
    //                 calPrice = new SafeDecimal(curPrice);
    //                 break;
    //             case FutureManualTradeType.stop_limit_market:
    //                 if (!triggerPrice) {
    //                     return "--";
    //                 }
    //                 calPrice = new SafeDecimal(triggerPrice);
    //                 break;
    //             default:
    //                 break;
    //         }
    //         let result = new SafeDecimal(0);
    //         if (new SafeDecimal(position.position).greaterThan(0)) {
    //             result = calPrice.sub(openPrice).mul(amountDecimal);
    //         } else {
    //             result = openPrice.sub(calPrice).mul(amountDecimal);
    //         }
    //         return NumberCommonUtils.formatterDecimalToStr(result, symbol.precision);
    //     }, [position, amount, price, symbol, curPrice, tradeType, triggerPrice]);
    // },
    // getCreateOrderRequest(params: FutureManualParams, $st: StringFormatter): FutureOrderRequest {
    //     const {
    //         amount,
    //         amountError,
    //         symbol,
    //         tradeType,
    //         triggerPrice,
    //         requiredMargin,
    //         orderType,
    //         side,
    //         price,
    //         isReduceOnly,
    //         isPostOnly,
    //         triggerType,
    //     } = params;
    //     if (amountError) {
    //         throw amountError;
    //     }
    //     let request: FutureOrderRequest = {
    //         symbol: symbol,
    //         orderType: orderType,
    //     };
    //     switch (tradeType) {
    //         case FutureManualTradeType.limit:
    //             if (!Number(price)) {
    //                 throw $st("trade_error_input_price");
    //             }
    //             SimpleTrading.parsePriceSupportTrading(price, symbol, $st);
    //             request.limit = {
    //                 symbol: symbol.symbol,
    //                 amount: amount,
    //                 side: side,
    //                 type: orderType,
    //                 price: price,
    //                 reduce_only: isReduceOnly,
    //                 time_in_force: isPostOnly ? FutureTimeInForce.GTX : FutureTimeInForce.GTC,
    //             };
    //             break;
    //         case FutureManualTradeType.market:
    //             request.market = {
    //                 symbol: symbol.symbol,
    //                 amount: amount,
    //                 side: side,
    //                 type: orderType,
    //                 reduce_only: isReduceOnly,
    //             };
    //             break;
    //         case FutureManualTradeType.stop_limit:
    //             if (!Number(triggerPrice)) {
    //                 throw $st("trade_please_input_trigger_price");
    //             }
    //             if (!Number(price)) {
    //                 throw $st("trade_error_input_price");
    //             }
    //             SimpleTrading.parsePriceSupportTrading(price, symbol, $st);
    //             request.stopLimit = {
    //                 symbol: symbol.symbol,
    //                 amount: amount,
    //                 stop_price: triggerPrice,
    //                 side: side,
    //                 type: orderType,
    //                 price: price,
    //                 reduce_only: isReduceOnly,
    //                 working_type: triggerType,
    //             };
    //             break;
    //         case FutureManualTradeType.stop_limit_market:
    //             if (!Number(triggerPrice)) {
    //                 throw $st("trade_please_input_trigger_price");
    //             }
    //             request.stopLimitMarket = {
    //                 symbol: symbol.symbol,
    //                 amount: amount,
    //                 stop_price: triggerPrice,
    //                 side: side,
    //                 type: orderType,
    //                 reduce_only: isReduceOnly,
    //                 working_type: triggerType,
    //             };
    //             break;
    //     }
    //     if (!Number(amount)) {
    //         throw $st("trade_error_input_quantity");
    //     }
    //     return request;
    // },
    calculateMarginCanBuy(margin, side, tradeType, tradePrice, markPrice, assumingPrice, leverage, symbol) {
        if (!Number(tradePrice)) {
            return "0";
        }
        const tradePriceD = new trade_utils_lib_1.SafeDecimal(tradePrice);
        const assumingPriceD = new trade_utils_lib_1.SafeDecimal(assumingPrice);
        const leverageD = new trade_utils_lib_1.SafeDecimal(leverage);
        const markPriceD = new trade_utils_lib_1.SafeDecimal(markPrice);
        const marginD = new trade_utils_lib_1.SafeDecimal(margin);
        // 方向
        const direction = new trade_utils_lib_1.SafeDecimal(side === TradeAPILib_1.ExchangeOrderSide.buy ? 1 : -1);
        let initMarginLoss = new trade_utils_lib_1.SafeDecimal(0);
        const isLimitOrder = tradeType === FutureManualTradeType.limit || tradeType === FutureManualTradeType.stop_limit;
        if (isLimitOrder) {
            initMarginLoss = direction.mul(markPriceD.sub(tradePriceD));
        }
        else {
            initMarginLoss = direction.mul(markPriceD.sub(assumingPriceD));
        }
        //(钱包余额 - a/杠杆倍数)/绝对值{min[0, 开仓方向x (标记价格 - 开仓价格)]}
        // 最大可开 = Min ((钱包余额 - 某杠杆倍数下最大可开仓名义价值/杠杆倍数)/绝对值{min[0, 开仓方向x (标记价格 - 开仓价格)]},
        // 钱包余额/（开仓价格/杠杆倍数 + 绝对值{min[0, 开仓方向x (标记价格 - 开仓价格)]})
        let _maxBuy = new trade_utils_lib_1.SafeDecimal(0);
        // 如果有开仓亏损
        if (initMarginLoss.lessThan(0)) {
            _maxBuy = marginD.div(assumingPriceD.div(leverageD).add(trade_utils_lib_1.SafeDecimal.min(0, initMarginLoss).abs()));
        }
        else {
            _maxBuy = marginD.mul(leverageD).div(assumingPriceD);
        }
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(_maxBuy, symbol.amount);
    },
};
